<template>
  <v-popover
    ref="popover"
    :trigger="trigger"
    :placement="position"
    :delay="delay"
    handle-resize
    v-on="listeners"
    class="popover"
  >
    <div class="popover-trigger">
      <slot />
    </div>

    <div
      slot="popover"
      class="popover-content"
    >
      <slot name="content" />
    </div>
  </v-popover>
</template>

<script>
import uniqueId from 'lodash/uniqueId'

export default {
  name: 'ws-popover',
  props: {
    trigger: {
      type: String,
      default: 'hover focus'
    },
    position: {
      type: String,
      default: 'auto'
    },
    delay: {
      type: [Number, Object],
      default: () => ({ show: 0, hide: 300 })
    }
  },
  data: () => ({
    name: uniqueId()
  }),
  computed: {
    listeners () {
      return this.$listeners || {}
    },
    classes () {
      return [
        `is-popover-${this.position}`,
        { 'is-popover-active': this.value }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

$color-scrollbar: transparent;

.popover{
  position: relative;
}

.popover-content {
  width: 450px;
  max-height: 137px;
  font-size: 12px;
  word-break: break-all;
  position: absolute;
  bottom: 100%;
  background-color: white;
  box-shadow: 0 0 40px 0 rgba(0, 0, 0, 0.15);
  right: 50%;
  transform: translate(15%, -20%);
  padding: 20px;

  @media (max-width: 800px) {
    width: 250px;
    transform: translate(15%, -20%);
  }

  &::after{
    content: '';
    position: absolute;
    bottom: -10px;
    width: 20px;
    height: 20px;
    background-color: white;
    transform: rotate(-45deg);
    right: 60px;
  }

  &::-webkit-scrollbar {
    //width: $size-7 / 3;
    //height: $size-7 / 3;
    //background-color: $color-scrollbar;
  }

  &::-webkit-scrollbar-thumb {
    //background-color: $grey-lighter;
    //border-radius: $size-7 / 2;
  }
}
</style>
